import { format } from 'date-fns/format';

/**
 * @deprecated Use @pflegia/util/functions/date-helpers instead
 */
export const dateService = {
  formatDate(date: string | Date, newFormat: string): string {
    // Remove timezone
    try {
      const inputDate = typeof date === 'string' ? new Date(date) : date;
      return format(new Date(inputDate.getUTCFullYear(), inputDate.getUTCMonth(), inputDate.getUTCDate()), newFormat);
    } catch {
      return date.toString();
    }
  },
};

/**
 * @deprecated Use @pflegia/util/functions/date-helpers instead
 */
export const formatDate = (language: string, publishedAt: number | string | Date) =>
  new Intl.DateTimeFormat(language === 'de' ? 'de-DE' : 'en-US', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(new Date(publishedAt));

/**
 * @deprecated Use @pflegia/util/functions/date-helpers instead
 */
export const dateFormat = 'dd.MM.yyyy';

/**
 * @deprecated Use @pflegia/util/functions/date-helpers instead
 */
export const inputDateFormat = 'yyyy-MM-dd';

/**
 * @deprecated Use @pflegia/util/functions/date-helpers instead
 */
export const inputMonthFormat = 'yyyy-MM';

/**
 * @deprecated Use @pflegia/util/functions/date-helpers instead
 */
export const monthYear = 'MMMM yyyy';
